// It provides compatibility with current request result action
// change payload key to results key
export const payloadUnwrapper = () => (next: any) => (action: any) => {
  if (action && action.meta && action.meta.unwrapPayload) {
    const { meta, payload = {}, ...rest } = action;

    return next({
      ...rest,
      result: payload,
    });
  }

  return next(action);
};
